import { useTheme } from "@mui/styles";
import {
  setLoading,
  setRoute,
  setTitle,
} from "app/store/transmission/slice/transmissionSlice";
import LoadingSpinner from "components/LoadingSpinner";
import PhysicianFilter from "components/pages/transmissions/filter/PhysicianFilter";
import TransmissionModals from "components/pages/transmissions/modal/TransmissionModals";
import TransmissionProcess from "components/pages/transmissions/table/TransmissionProcess";

import TransmissionTable from "components/pages/transmissions/table/TransmissionTable";
import TransmissionTabs from "components/pages/transmissions/tabs/TransmissionTabs";
import "pages/transmission/Transmission.css";

import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

const Transmission = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const role = localStorage.getItem("role");
  const clinicName = localStorage.getItem("clinicName");

  const { route, selectedTab, isLoading } = useSelector(
    (state) => state.transmission
  );
  const { currentUser } = useSelector((state) => state.auth);
  const { accountsMapper } = useSelector((state) => state.account);

  const [rowSelection, setRowSelection] = useState({});
  const initialRender = useRef(true);

  const [isTabSynced, setIsTabSynced] = useState(false);

  const { pathname } = useLocation();

  const tabStyles = useCallback(
    (currentPage, isDisplayed) => ({
      border: selectedTab === currentPage ? "1px solid #E0E0E0" : "none",
      borderBottom:
        selectedTab === currentPage ? theme.palette.background.paper : "none",
      display: isDisplayed ? "block" : "none",
      backgroundColor:
        selectedTab === currentPage
          ? theme.palette.background.paper
          : "transparent",
    }),
    [selectedTab, theme]
  );

  const getView = useCallback(() => {
    const segments = pathname.split("/").filter(Boolean);
    const lastSegment = segments[segments.length - 1];
    return lastSegment === "transmissions" ? "active" : lastSegment;
  }, [pathname]);

  useEffect(() => {
    const activeTab = initialRender.current ? getView() : selectedTab;

    dispatch(setTitle({ view: activeTab, type: "transmission" }));
    dispatch(setRoute(activeTab));
    dispatch(setLoading(false));
    setIsTabSynced(true);
  }, [
    dispatch,
    getView,
    navigate,
    pathname,
    route,
    selectedTab,
    initialRender,
  ]);

  useEffect(() => {
    if (getView() && initialRender.current) {
      initialRender.current = false;
      return;
    }

    if (!initialRender.current) {
      navigate(route);
    }
  }, [navigate, route, getView]);

  return (
    <>
      <TransmissionTabs
        role={role}
        view={selectedTab}
        isLoading={isLoading}
        tabStyles={tabStyles}
      />

      <div style={isLoading ? { overflow: "hidden" } : {}}>
        {isLoading ? (
          <div
            className="trans-table__loading"
            style={{ backgroundColor: theme.palette.background.paper }}
          >
            <LoadingSpinner />
          </div>
        ) : (
          !isLoading && (
            <>
              <TransmissionProcess role={role} />
              <TransmissionModals setRowSelection={setRowSelection} />

              {getView() === "signed-archived" && (
                <div style={{ color: "red", padding: "50px 0" }}>
                  Signed archived table needs to be implemented
                </div>
              )}
              {role === "clinic" &&
                (clinicName !== "Centra" ||
                  (clinicName === "Centra" &&
                    selectedTab === "clinic-review")) &&
                !(
                  currentUser?.role === "physician" &&
                  accountsMapper[clinicName]?.settings
                    ?.show_only_assigned_reports
                ) && <PhysicianFilter />}

              {selectedTab && (isTabSynced || selectedTab === getView()) && (
                <TransmissionTable
                  view={selectedTab}
                  role={role}
                  theme={theme}
                  rowSelection={rowSelection}
                  setRowSelection={setRowSelection}
                />
              )}
            </>
          )
        )}
      </div>
    </>
  );
};

export default Transmission;
